import { AxiosRequestConfig } from "axios";

import { ApiError, AudienceBuild, AudienceTravelTimeRequest } from "@/types";
import { fetchData } from "@/utils";


type RequestTraveltimeApiResponse = {
  data: { audience_id: string };
  error: ApiError | null;
};

export const requestTravelTime = async (
  accessToken: string,
  traveltime: AudienceTravelTimeRequest,
): Promise<RequestTraveltimeApiResponse> => {
  const url = `${process.env.REACT_APP_API_URL}/traveltime/request`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: traveltime,
  };

  return fetchData(config);
};
